(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true'; root.classList.add('js-ready');
    const form = root.querySelector('.boo-product-form');
    const message = root.querySelector('[data-form-message]');
    root.querySelectorAll('[data-variant]').forEach(input => input.addEventListener('change', () => {
      if(input.checked) root.querySelector('[data-price]').textContent=input.dataset.price;
    }));
    root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      const image=root.querySelector('[data-gallery-main]'); image.classList.add('is-changing'); image.onload=()=>image.classList.remove('is-changing'); image.onerror=()=>image.classList.remove('is-changing'); image.src=button.dataset.image;
      root.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    const qty = form?.querySelector('[name="quantity"]');
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      qty.value = Math.min(10, Math.max(1, (parseInt(qty.value,10)||1) + Number(button.dataset.quantity)));
    }));
    const shopRoot = window.Shopify?.routes?.root || '/';
    async function add(buy) {
      if (!form.reportValidity()) return;
      const buttons = [...form.querySelectorAll('button')]; const disabled=buttons.map(b=>b.disabled); buttons.forEach(b => b.disabled = true);
      message.textContent = '';
      try {
        const response = await fetch(shopRoot+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[name="id"]:checked').value,quantity:Number(qty.value)}]})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || message.dataset.error);
        if (buy) {window.location.assign(shopRoot+'checkout');return;}
        message.textContent = message.dataset.success;
        const cart = await fetch(shopRoot+'cart.js').then(r=>r.json());
        root.querySelector('[data-cart-count]').textContent = cart.item_count;
      } catch(error) {message.textContent = error.message || message.dataset.error;}
      finally {buttons.forEach((b,i) => b.disabled = disabled[i]);}
    }
    form?.addEventListener('submit', e=>{e.preventDefault();add(false);});
    root.querySelector('[data-buy-now]')?.addEventListener('click',()=>add(true));
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const video=root.querySelector('[data-hero-video]');
    const toggle=root.querySelector('[data-video-toggle]');
    if(video && toggle){
      const second=video.cloneNode(true);
      second.removeAttribute('data-hero-video');second.setAttribute('aria-hidden','true');
      second.removeAttribute('aria-label');second.preload='auto';second.muted=true;
      video.after(second);video.preload='auto';video.muted=true;
      let active=video,standby=second,blending=false,running=false,starting=false,raf=0;
      const fade=.65;
      const label=()=>{toggle.textContent=running?toggle.dataset.pause:toggle.dataset.play;toggle.setAttribute('aria-pressed',String(running));};
      const tick=()=>{
        if(!running)return;
        if(blending){
          const fraction=Math.min(1,standby.currentTime/fade);
          standby.style.opacity=String(fraction);
          if(fraction>=1){
            active.pause();active.style.opacity='0';active.currentTime=0;
            [active,standby]=[standby,active];blending=false;
          }
        }else if(!starting&&Number.isFinite(active.duration)&&active.duration>fade*2&&active.currentTime>=active.duration-fade&&standby.readyState>=2){
          starting=true;standby.currentTime=0;standby.style.zIndex='2';active.style.zIndex='1';
          standby.play().then(()=>{starting=false;blending=true;}).catch(()=>{starting=false;active.loop=true;});
        }
        raf=requestAnimationFrame(tick);
      };
      const pause=()=>{running=false;video.pause();second.pause();cancelAnimationFrame(raf);label();};
      const play=async()=>{try{await active.play();if(blending)await standby.play();active.style.opacity='1';running=true;label();cancelAnimationFrame(raf);tick();}catch{pause();}};
      [video,second].forEach(v=>v.addEventListener('ended',()=>{if(v===active&&!blending&&running){v.currentTime=0;v.play().catch(pause);}}));
      toggle.addEventListener('click',()=>running?pause():play());
      document.addEventListener('visibilitychange',()=>{if(document.hidden)pause();});
      reduced.addEventListener('change',()=>{if(reduced.matches)pause();});
      if(!reduced.matches)play();else label();
    }
    if(!reduced.matches&&'IntersectionObserver' in window){
      root.classList.add('boo-motion');
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.08});
      root.querySelectorAll('.boo-gallery,.boo-product-copy,.boo-story-copy>*,.boo-lookbook>h2,.boo-lookbook>p,.boo-size-guide>div,.boo-faq>div,.boo-final>h2,.boo-final>.boo-button').forEach((el,i)=>{el.classList.add('boo-reveal');el.style.setProperty('--boo-delay',`${i%3*75}ms`);observer.observe(el);});
      const progress=document.createElement('div');progress.className='boo-progress';progress.setAttribute('aria-hidden','true');root.prepend(progress);
      let pending=false;
      const update=()=>{const range=document.documentElement.scrollHeight-innerHeight;progress.style.transform=`scaleX(${range>0?scrollY/range:0})`;pending=false;};
      window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();
    }
    const sticky=root.querySelector('[data-sticky]');const shop=root.querySelector('#shop');
    if(sticky&&shop){const update=()=>{const rect=shop.getBoundingClientRect();sticky.classList.toggle('visible',rect.bottom<0);};window.addEventListener('scroll',update,{passive:true});update();}
    root.querySelectorAll('a[href="#size-guide"]').forEach(link=>link.addEventListener('click',()=>root.querySelector('#size-guide').setAttribute('tabindex','-1')));
  }
  document.querySelectorAll('[data-boo-storefront]').forEach(init);
  document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-boo-storefront]')));
})();
